// Modules
import React, { Fragment } from 'react'
// Application
import { useScreenSize } from 'hooks'

import { StyledBanner, CustomDesktopIllustration, CustomHeading } from './styles'

export const LateralBannerLoginAuto = () => {
    const { isDesktop } = useScreenSize()

    return isDesktop() ? (
        <StyledBanner>
            <CustomHeading>Sua plataforma de saúde integrada</CustomHeading>

            <CustomDesktopIllustration />
        </StyledBanner>
    ) : (
        <Fragment />
    )
}
